export default function YouTube() {
  return <i className="text-3xl fa-brands fa-youtube" />;
}
